import type { RoomDefaults } from "../lib/storage.js";
export function RoomRules({
  value,
  onChange,
}: {
  value: RoomDefaults;
  onChange: (v: RoomDefaults) => void;
}): JSX.Element {
  const rows = [
    [
      "anyonePause",
      "Паузу может ставить каждый",
      "Иначе управляет только ведущий",
    ],
    ["reactions", "Реакции поверх кадра", "Всплывают там, куда нажали"],
    ["drawing", "Рисование", `Линии тают через ${value.trailSeconds} с`],
  ] as const;
  return (
    <>
      <div>
        {rows.map(([key, title, sub]) => (
          <button
            key={key}
            type="button"
            className="toggle-row"
            role="switch"
            aria-checked={value[key]}
            onClick={() => onChange({ ...value, [key]: !value[key] })}
          >
            <span className="toggle-row__text">
              <span className="toggle-row__title">{title}</span>
              <span className="toggle-row__sub">{sub}</span>
            </span>
            <span className="toggle" data-on={value[key] || undefined}>
              <span className="toggle__knob" />
            </span>
          </button>
        ))}
      </div>
      <p className="helper">Время жизни рисунка</p>
      <div className="choice-row">
        {[1, 4, 8, 30, 120].map((n) => (
          <button
            key={n}
            type="button"
            aria-pressed={value.trailSeconds === n}
            onClick={() => onChange({ ...value, trailSeconds: n })}
          >
            {n} с
          </button>
        ))}
      </div>
    </>
  );
}
